import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const TopBar = styled.img`
  width: 50px;
`;

export const TitleTxt = styled.div`
  font-size: 49.2px;
  font-weight: bold;
  color: #971a35;
  padding-left: 100px;
`;

export const BodyTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 200px;
  gap: 20px;
`;

export const SubTitleTxt = styled.div`
  font-size: 28px;
  font-weight: bold;
  color: #971a35;
`;

export const SubTitleTxt1 = styled.div`
  font-size: 22px;
  font-weight: 400;
  color: #971a35;
`;

export const TextBlock = styled.div`
  font-size: 14px;
  color: black;
  //   width: 60%;
`;

export const TextBlock1 = styled.div`
  font-size: 14px;
  color: black;
  width: 60%;
`;

export const TextBlock2 = styled.div`
  font-size: 14px;
  color: black;
  width: 70%;
`;

export const ImgTxtContainer = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

export const LeftContainer = styled.img`
  height: 300px;
`;

export const RightContainer = styled.div`
  width: 40%;
  font-size: 14px;
  color: black;
`;
